import { useTranslation } from 'react-i18next';
import TimePicker from '../ui/TimePicker';

const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const defaultOperatingHours = () =>
  DAYS.map((day) => ({
    day,
    openTime: '09:00',
    closeTime: '18:00',
    isClosed: false,
  }));

const OperatingHoursEditor = ({ hours, onChange }) => {
  const { t } = useTranslation();

  const updateDay = (index, field, value) => {
    const next = hours.map((row, i) =>
      i === index ? { ...row, [field]: value } : row
    );
    onChange(next);
  };

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-zinc-700 dark:text-zinc-300">{t('salon.operatingHours.title')}</p>
      <div className="space-y-2">
        {hours.map((row, index) => (
          <div
            key={row.day}
            className="grid grid-cols-2 items-center gap-2 text-sm sm:grid-cols-[3rem_1fr_1fr_auto]"
          >
            <span className="col-span-2 font-medium text-zinc-600 dark:text-zinc-500 sm:col-span-1 sm:font-normal">
              {t(`salon.operatingHours.days.${row.day}`)}
            </span>
            <TimePicker
              id={`open-${row.day}`}
              compact
              value={row.openTime}
              disabled={row.isClosed}
              onChange={(e) => updateDay(index, 'openTime', e.target.value)}
            />
            <TimePicker
              id={`close-${row.day}`}
              compact
              value={row.closeTime}
              disabled={row.isClosed}
              onChange={(e) => updateDay(index, 'closeTime', e.target.value)}
            />
            <label className="col-span-2 flex items-center gap-1 text-xs text-zinc-600 dark:text-zinc-500 sm:col-span-1">
              <input
                type="checkbox"
                checked={row.isClosed}
                onChange={(e) => updateDay(index, 'isClosed', e.target.checked)}
              />
              {t('salon.operatingHours.closed')}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OperatingHoursEditor;
